import type { ObjectDirective } from "vue";

// Sólo cambia la presentación: v-model conserva el valor y su precisión.
function formatear(el: HTMLInputElement) {
  if (!el.value.trim()) return;
  const valor = Number(el.value);
  if (Number.isFinite(valor)) el.value = valor.toFixed(2);
}

const importe: ObjectDirective<HTMLInputElement> = {
  mounted(el) {
    if (!el.hasAttribute("step")) el.step = "0.01";
    formatear(el);
    el.addEventListener("blur", alSalir);
  },
  updated(el) {
    // No interrumpir la escritura ni mover el cursor.
    if (document.activeElement !== el) formatear(el);
  },
  beforeUnmount(el) {
    el.removeEventListener("blur", alSalir);
  },
};

function alSalir(event: Event) {
  formatear(event.target as HTMLInputElement);
}

export default importe;
